export const PANELIST_SESSION_STORAGE_KEY = 'trinidad_panelist_session';
export const PANELIST_SESSION_CHANGED_EVENT = 'trinidad-panelist-session-changed';

export type PanelistSession = {
  accessToken: string;
  expiresAt: string | null;
  refreshToken: string;
  tokenType: string;
};

export function getPanelistSessionStorage(): Storage | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function readStoredPanelistSession(
  storage: Storage | null = getPanelistSessionStorage(),
): PanelistSession | null {
  const raw = storage?.getItem(PANELIST_SESSION_STORAGE_KEY);

  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw) as Partial<PanelistSession>;

    if (!parsed.accessToken || !parsed.refreshToken) {
      return null;
    }

    return {
      accessToken: parsed.accessToken,
      expiresAt: parsed.expiresAt ?? null,
      refreshToken: parsed.refreshToken,
      tokenType: parsed.tokenType ?? 'bearer',
    };
  } catch {
    return null;
  }
}

export function writePanelistSession(
  session: PanelistSession,
  storage: Storage | null = getPanelistSessionStorage(),
) {
  storage?.setItem(PANELIST_SESSION_STORAGE_KEY, JSON.stringify(session));
  notifyPanelistSessionChanged();
}

export function clearPanelistSession(storage: Storage | null = getPanelistSessionStorage()) {
  storage?.removeItem(PANELIST_SESSION_STORAGE_KEY);
  notifyPanelistSessionChanged();
}

export function notifyPanelistSessionChanged() {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new Event(PANELIST_SESSION_CHANGED_EVENT));
}
